/* Native accessory variants remain native. Cot extras submit real separate SKUs. */
(() => {
  'use strict';
  if (window.__amcAccessoryImages) return;
  window.__amcAccessoryImages = true;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style:'currency', currency:window.Shopify?.currency?.active || 'USD'
  }).format(cents / 100);
  const instances = new WeakMap(), paymentBases = new WeakMap();
  const positive = n => Number.isSafeInteger(n) && n > 0;
  function updateTerms(root, total) {
    root.querySelectorAll('shopify-payment-terms').forEach(terms => {
      let base = paymentBases.get(terms);
      if (!base) {try {base = JSON.parse(terms.getAttribute('shopify-meta'));} catch (_) {return;} if (!base) return; paymentBases.set(terms,base);}
      const variant = base.variants?.find(v => String(v.id) === root.querySelector('form[action*="/cart/add"] [name=id]')?.value) || base.variants?.[0] || base;
      const count = variant.number_of_payment_terms || base.number_of_payment_terms;
      if (!count) return;
      const meta = {...base, type:'cart', full_price_amount:total/100, full_price:money(total),
        price_per_term_amount:Math.round(total/count)/100, price_per_term:money(Math.round(total/count)),
        number_of_payment_terms:count, eligible:variant.eligible !== false && total/100 >= base.min_price_amount && total/100 <= base.max_price_amount};
      delete meta.variants;
      const serialized = JSON.stringify(meta);
      if (terms.getAttribute('shopify-meta') !== serialized) terms.setAttribute('shopify-meta', serialized);
      terms.removeAttribute('variant-id');
    });
  }
  function init() {
    document.querySelectorAll('[data-amc-cot-accessories]').forEach(box => {
      if (instances.has(box)) return;
      const form = box.closest('form'), root = box.closest('.amc-card-option-modal, product-info');
      if (!form || !root) return;
      const rows = [...box.querySelectorAll('[data-cot-item]')];
      const isCot = Boolean(box.querySelector('[data-cot-decline]'));
      const state = {items:[], reviews:[], valid:true, decision:!isCot, isCot};
      const grid = box.querySelector('.amc-cot-accessories__grid');
      const primary = isCot ? rows.filter(row => Boolean(row.querySelector('[data-cot-primary]'))) : rows;
      const extras = rows.filter(row => !primary.includes(row));
      primary.sort((a,b) => (/slider board/i.test(a.textContent)?-1:0)-(/slider board/i.test(b.textContent)?-1:0)).forEach(row=>grid.append(row));
      if (extras.length) {
        const details=document.createElement('details');details.className='amc-cot-more';
        const summary=document.createElement('summary');summary.textContent='More compatible accessories';
        details.append(summary);extras.forEach(row=>details.append(row));grid.after(details);
      }
      instances.set(box,state);
      function update() {
        if (!box.isConnected) return;
        const qInput = root.querySelector('input[name=quantity]:not([type=hidden])');
        const q = Number(qInput?.value || 1);
        const variantInput=form.querySelector('[data-amc-option-variant-id]');
        if(variantInput?.value){
          try{
            const variants=JSON.parse(form.querySelector('[data-amc-option-variants]')?.textContent||'[]');
            const variant=variants.find(v=>String(v.id)===String(variantInput.value));
            if(variant) box.dataset.basePrice=String(variant.price);
          }catch(_){}
        }
        let total = Number(box.dataset.basePrice) * q;
        state.valid = positive(q) && (!qInput || qInput.checkValidity());
        state.items = [];
        state.reviews = [...box.querySelectorAll('[data-cot-fit-request]:checked')].map(el=>el.value);
        state.decision = !isCot || box.querySelector('[data-cot-decline]')?.checked || state.reviews.length > 0;
        rows.forEach(row => {
          const choice = row.querySelector('[data-cot-choice]'), selected = choice.selectedOptions[0];
          const checked = row.querySelector('[data-cot-check]').checked;
          const quantity = row.querySelector('[data-cot-quantity]');
          quantity.disabled = !checked;
          if (!selected) return;
          let priceBadge = row.querySelector('[data-cot-live-price]');
          if (!priceBadge) {
            priceBadge = document.createElement('span');
            priceBadge.dataset.cotLivePrice = '';
            priceBadge.className = 'amc-cot-accessories__live-price';
            row.querySelector('.amc-cot-accessories__value')?.after(priceBadge);
          }
          priceBadge.textContent = `+ ${money(Number(selected.dataset.price))} each`;
          const image = row.querySelector('[data-cot-image]');
          if (selected.dataset.image && image.getAttribute('src') !== selected.dataset.image) image.src = selected.dataset.image;
          image.hidden = !selected.dataset.image;
          image.alt = selected.dataset.title + (selected.dataset.imageExact === 'false' ? ' - product reference view' : ' - ' + selected.textContent);
          const note = row.querySelector('[data-cot-image-note]');
          if (note) note.hidden = selected.dataset.imageExact !== 'false';
          row.querySelector('[data-cot-link]').href = selected.dataset.url;
          if (checked) {
            state.decision = true;
            const n = Number(quantity.value), id = Number(selected.value), price = Number(selected.dataset.price);
            state.valid = state.valid && positive(n) && quantity.checkValidity() && positive(id) && Number.isSafeInteger(price);
            state.items.push({id, quantity:n});
            total += price * n;
          }
        });
        const error = box.querySelector('[data-cot-error]');
        error.hidden = state.valid && (!state.submitted || state.decision);
        error.textContent = !state.valid ? 'Enter a valid whole-number quantity before adding these items.' : !state.decision ? 'Choose an accessory or select “No, thank you” to continue.' : '';
        box.dataset.totalCents = state.valid ? String(total) : '';
        const status=root.querySelector('[data-amc-option-status]');
        if(status && isCot){status.textContent=state.decision?'Ready to add your selection.':'Choose an accessory or select “No, thank you.”';status.classList.toggle('is-ready',state.decision);}
        box.querySelector('[data-cot-total]').textContent = state.valid ? `Selected total: ${money(total)}` : 'Check accessory quantities';
        if(root.matches('.amc-card-option-modal') && state.valid){
          const label=form.querySelector('button[type="submit"]>span:not(.loading__spinner)');
          if(label) label.textContent=`Add to cart · ${money(total)}`;
        }
        const priceRegion = root.querySelector('[id^="price-"]');
        if (priceRegion && state.valid) {
          const target = priceRegion.querySelector('.price--on-sale .price__sale .price-item--sale') || priceRegion.querySelector('.price__regular .price-item--regular');
          if (target && target.textContent.trim() !== money(total)) target.textContent = money(total);
          const kicker = priceRegion.querySelector('.amc-price-kicker');
          if (kicker && kicker.textContent !== 'Selected total') kicker.textContent = 'Selected total';
          const compare = priceRegion.querySelector('.price__sale .price-item--regular');
          if (compare) compare.style.display = state.items.length || q !== 1 ? 'none' : '';
          priceRegion.querySelectorAll('.amc-price-list-label,.amc-price-support--product').forEach(label => {
            label.hidden = state.items.length > 0 || q !== 1;
            label.style.display = label.hidden ? 'none' : '';
          });
        }
        root.querySelectorAll('.shopify-payment-button').forEach(el => { el.hidden = state.items.length > 0 || state.reviews.length > 0 || !state.decision; });
        if (state.valid) updateTerms(root,total);
        document.dispatchEvent(new CustomEvent('amc:accessory-price-change'));
      }
      box.addEventListener('change',event=>{
        if(event.target.matches('[data-cot-decline]') && event.target.checked) box.querySelectorAll('[data-cot-check],[data-cot-fit-request]').forEach(input=>input.checked=false);
        if(event.target.matches('[data-cot-check],[data-cot-fit-request]') && event.target.checked){const decline=box.querySelector('[data-cot-decline]');if(decline)decline.checked=false;}
        update();
      });
      box.addEventListener('input',update);
      root.addEventListener('change',event => {if (event.target.name === 'quantity' || event.target.matches('[data-amc-option-choice]')) update();});
      root.addEventListener('input',event => {if (event.target.name === 'quantity') update();});
      state.update = update;
      update();
    });
  }
  // Called inside the existing guarded native product-form request.
  window.amcAppendAccessoryItems = (form, data) => {
    const box = form.querySelector('[data-amc-cot-accessories]'), state = box && instances.get(box);
    if (!state) {
      if(box) throw new Error('Accessory choices are still loading. Please try again.');
      return;
    }
    state.submitted = true;
    state.update();
    if (!state.decision) { box.focus(); throw new Error('Choose an accessory or select “No, thank you” to continue.'); }
    if (!state.valid) throw new Error('Check the accessory quantities before adding to cart.');
    if(state.isCot)data.set('properties[Included with cot]','Securement straps; durable mattress pad; economy cot cover (black). Included at no extra charge.');
    data.set('properties[Accessory choice]',state.items.length ? 'Selected accessories added separately' : state.reviews.length ? 'Fit review requested; no accessory charges' : state.isCot ? 'No, thank you' : 'Equipment only');
    if(state.reviews.length) data.set('properties[Accessory fit review]',state.reviews.join('; '));
    if (!state.items.length) return;
    const baseId = data.get('id'), quantity = data.get('quantity') || '1';
    data.delete('id');data.delete('quantity');
    data.set('items[0][id]',baseId);data.set('items[0][quantity]',quantity);
    for (const [key,value] of [...data.entries()]) {
      if (/^properties\[/.test(key)) {data.delete(key);data.append(`items[0][${key.replace('[','][')}`,value);}
      if (key === 'selling_plan') {data.delete(key);data.set('items[0][selling_plan]',value);}
    }
    state.items.forEach((item,index) => {
      data.set(`items[${index+1}][id]`,String(item.id));
      data.set(`items[${index+1}][quantity]`,String(item.quantity));
    });
  };
  init();
  let queued = false;
  new MutationObserver(() => {if (!queued) {queued=true;queueMicrotask(() => {queued=false;init();});}})
    .observe(document.body,{childList:true,subtree:true});
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange,event => {
      document.querySelectorAll('[data-amc-cot-accessories]').forEach(box => {
        const root = box.closest('product-info');
        if (root?.dataset.section === String(event.data?.sectionId) && event.data?.variant) {
          box.dataset.basePrice = String(event.data.variant.price);
          instances.get(box)?.update();
        }
      });
    });
  }
})();
